'use client'

import ChatIcon from '@/components/icons/chat'
import CurrencyIcon from '@/components/icons/currency'
import GiftIcon from '@/components/icons/gift'
import MenuIcon from '@/components/icons/menu'
import SearchIcon from '@/components/icons/search'
import { useContext } from 'react'
import { LayoutContext } from '../layout-context'
import Item from './item'
import './mobile-nav.scss'
import { Link } from '@/navigation'
import useAuth from '@/hooks/use-auth'
import clsx from 'clsx'

export default function MobileNav() {
  const { sidebarOpen, onSidebarOpenChange } = useContext(LayoutContext)

  const { isAuthenticated: isAuth } = useAuth()
  return (
    <>
      <Item
        icon={<MenuIcon />}
        label='Menu'
        onClick={() => {
          onSidebarOpenChange(!sidebarOpen)
        }}
      />

      <Item icon={<SearchIcon />} label='Search' href={'/search'} />

      <Link href={isAuth ? '?modal=wallet&tab=deposit' : ''}>
        <button
          className={clsx(
            'mobile-nav__deposit',
            isAuth
              ? 'mobile-nav__deposit--enabled'
              : 'mobile-nav__deposit--disabled'
          )}
          tabIndex={0}
          type='button'
          disabled={!isAuth}
          {...(isAuth ? {} : { tabIndex: -1 })}
        >
          <CurrencyIcon />
          <span>Deposit</span>
        </button>
      </Link>

      <Item
        label='Rewards'
        icon={<GiftIcon />}
        href={isAuth ? '/profile/rewards' : '?modal=auth&tab=login'}
      />

      <Item
        icon={<ChatIcon />}
        onClick={() => {
          console.log('chat')
        }}
        label='Chat'
        style={{
          opacity: 0.5,
        }}
        disabled
      />
    </>
  )
}
